import React, { useState, useEffect, useMemo } from 'react';
import Modal from 'react-modal';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

// 스타일 및 컴포넌트
import Styles from './BankingHeader.module.css';
import BankingList_Print from './detail/BankingList_Print';
import BankingHeader_modal from './BankingHeader_modal';

// 이미지 자원
import Headername from '../img/gradiantbioconvergence/header-name.png';
import HomeIconOrange from '../img/common/home_icon_orange.png';
import HomeIconGrey from '../img/common/home_icon_grey.png';
import DraftIconGrey from '../img/common/draftMenuIcon.png';
import DraftIconOrange from '../img/common/draftMenuIconOrange.png';
import AmericaFlag from '../img/nationalFlag/AmericaNationalFlag.jpg';
import KoreaFlag from '../img/nationalFlag/KoreaNationalFlag.jpg';
import PersonIcon from '../img/common/personIcon.png';
import DNAIcon_gray from '../img/icon/DNAIcon_gray_small.png';
import DNAIcon_orange from '../img/icon/DNAIcon_orange_small.png';
import DodbogiOrange from '../img/common/dodbogi_orange.png';
import DodbogiGray from '../img/common/dodbogi_gray.png';

function BankingHeader() {
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const [selectedTab, setSelectedTab] = useState('dashboard');
    const [printModalIsOpen, setPrintModalIsOpen] = useState(false);
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);

    // 1. 경로와 탭 매핑 (URL 변경 시 탭 상태 동기화)
    useEffect(() => {
        const pathMap = {
            '/': 'dashboard',
            '/draftpage': 'drafts',
            '/NGS': 'NGS',
            '/integratedsearch': 'search'
        };
        setSelectedTab(pathMap[location.pathname] || '');
    }, [location.pathname]);

    // 2. 언어 옵션 메모이제이션 (매 렌더링마다 재생성 방지)
    const languageOptions = useMemo(() => [
        {
            value: 'en',
            label: (<div><img src={AmericaFlag} alt="USA" style={{ width: '20%', marginRight: '10px' }} />English</div>)
        },
        {
            value: 'ko',
            label: (<div><img src={KoreaFlag} alt="Korea" style={{ width: '20%', marginRight: '10px' }} />한국어</div>)
        },
    ], []);

    const handleLanguageChange = (selectedOption) => {
        i18n.changeLanguage(selectedOption.value);
    };

    // 3. 네비게이션 메뉴 데이터화 (코드 중복 제거)
    const menuItems = [
        { id: 'dashboard', to: '/', label: 'DASHBOARD', activeIcon: HomeIconOrange, inactiveIcon: HomeIconGrey },
        { id: 'drafts', to: '/draftpage', label: 'LIST OF DRAFTS', activeIcon: DraftIconOrange, inactiveIcon: DraftIconGrey },
        { id: 'NGS', to: '/NGS', label: 'NGS ANALYSIS', activeIcon: DNAIcon_orange, inactiveIcon: DNAIcon_gray },
        { id: 'search', to: '/integratedsearch', label: 'INTEGRATED SEARCH', activeIcon: DodbogiOrange, inactiveIcon: DodbogiGray },
    ];

    return (
        <div className={Styles.headerFrame}>
            <span className={Styles.headerNameSpan}>
                <Link to="/">
                    <img src={Headername} className={Styles.headername} alt="Logo" />
                </Link>
            </span>

            <span className={Styles.rightHeader}>
                <span />
                {/* 메뉴 반복 렌더링 */}
                {menuItems.map((item) => (
                    <span
                        key={item.id}
                        className={selectedTab === item.id ? Styles.selectedTab : Styles.dashBoardSpan}
                        onClick={() => setSelectedTab(item.id)}
                    >
                        <Link to={item.to} className={Styles.linkNoStyle}>
                            <img
                                src={selectedTab === item.id ? item.activeIcon : item.inactiveIcon}
                                className={Styles.homeIcon}
                                alt={item.id}
                            />
                            {t(item.label)}
                        </Link>
                    </span>
                ))}

                {/* 빈 공간 유지 */}
                <span className={Styles.testBox}></span>
                <span className={Styles.testBox}></span>

                <span className={Styles.languageSpan}>
                    <Select
                        defaultValue={languageOptions.find(opt => opt.value === i18n.language)}
                        onChange={handleLanguageChange}
                        options={languageOptions}
                        className="language-selector"
                        classNamePrefix="select"
                    />
                </span>

                <span className={Styles.personSpan}>
                    <img
                        src={PersonIcon}
                        className={Styles.personIcon}
                        onClick={() => setIsUserModalOpen(!isUserModalOpen)}
                        alt="User"
                    />
                    {isUserModalOpen && (
                        <BankingHeader_modal onClose={() => setIsUserModalOpen(false)} />
                    )}
                </span>
            </span>

            {/* 주석 처리된 바코드 다운로드 기능 유지 필요 시 참조 */}
            <Modal
                isOpen={printModalIsOpen}
                onRequestClose={() => setPrintModalIsOpen(false)}
                style={customStyles}
            >
                <BankingList_Print />
                <button onClick={() => setPrintModalIsOpen(false)}>{t('Cancel')}</button>
            </Modal>
        </div>
    );
}

const customStyles = {
    content: {
        width: '500px',
        margin: 'auto',
    },
};

export default BankingHeader;